module.exports = __webpack_public_path__ + "static/media/mn24.ddbb2e94.jpeg";